export default "__VITE_ASSET__CELzGD6Z__"